import React from "react"
import FieldProto_FormElement from "../../../../proto/render/form-element";
import FieldToggle_ComponentStatefull, {ToggleSize} from "../components/toggle-statefull";

export default class FieldToggle_FormElement extends FieldProto_FormElement {

    render() {
        return <FieldToggle_ComponentStatefull className    = {Classes("no-margin", this.props.className)}
                                               field        = {this.props.field}
                                               isDisabled   = {this.props.disabled}
                                               size         = {this.props.configOptions?.size || ToggleSize.SIZE_20}
                                               value        = {this.value}
                                               onChange     = {this.onChange}/>
    }

}